import { render, staticRenderFns } from "./privateLetter.vue?vue&type=template&id=5e489cd2&scoped=true&"
import script from "./privateLetter.vue?vue&type=script&lang=js&"
export * from "./privateLetter.vue?vue&type=script&lang=js&"
import style0 from "./privateLetter.vue?vue&type=style&index=0&id=5e489cd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e489cd2",
  null
  
)

export default component.exports